// Partners section on the Home page: displays partner logos (scrolling pills).
import { useTranslation } from "react-i18next";
import Section from "./Section";
import { partners } from "../../mock/homeData";
import PartnerPills from "./PartnerPills";

function PartnersSection() {
  const { t } = useTranslation();

  return (
    <Section
      id="partners"
      eyebrow={t("home.partners.eyebrow")}
      title={t("home.partners.title")}
      variant="muted"
    >
      <PartnerPills partners={partners} />
    </Section>
  );
}

export default PartnersSection;
